<div class="divrel">
  <div class="master-grid" [ngBusy]="busyOptions">
    <div class="grid-tools" *ngIf="showGridTools">
      <div class="row">
        <div class="col-md-10">
          <ng-content></ng-content>
        </div>
        <div class="col-md-2">
          <div class="btn-group pull-right">
            <button
              type="button"
              class="btn btn-default dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="fa fa-wrench"></i> Grid Tools <span class="caret"></span>
            </button>
            <ul class="dropdown-menu">
              <li (click)="showOptionalColumns()" *ngIf="hasHiddenColumns">
                <a href="javascript:void(0)">Show All Columns</a>
              </li>
              <li (click)="hideOptionalColumns()" *ngIf="alwaysShowOptionalColumns">
                <a
                  href="javascript:void(0)"
                  title="Hides optional columns on smaller window size or lower screen resolutions"
                  >Hide Optional Columns</a
                >
              </li>
              <li
                role="separator"
                class="divider"
                *ngIf="hasHiddenColumns || alwaysShowOptionalColumns"
              ></li>
              <li (click)="clearFilter()"><a href="javascript:void(0)">Clear Filters</a></li>
              <li (click)="clearSort()"><a href="javascript:void(0)">Reset Sorting</a></li>
              <li role="separator" class="divider" *ngIf="hasPagination"></li>
              <li (click)="fitColumns()"><a href="javascript:void(0)">Fit Columns</a></li>
              <li (click)="autoSizeColumns()"><a href="javascript:void(0)">AutoSize Columns</a></li>
              <li role="separator" class="divider" *ngIf="hasPagination"></li>
              <ng-container *ngFor="let size of pageSizeOptions">
                <li (click)="pageSize = size" *ngIf="hasPagination">
                  <a href="javascript:void(0)">{{ size }} items per page</a>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <ag-grid-angular
      id="{{ identifier }}"
      #agGrid
      [rowData]="data"
      [ngStyle]="gridStyle"
      class="ag-theme-alpine"
      [components]="frameworkComponents"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      (cellValueChanged)="onCellValueChanged($event)"
      (cellDoubleClicked)="onCellDoubleClicked($event)"
      (modelUpdated)="onModelUpdated()"
      [enableCellTextSelection]="true"
      [modules]="modules"
    ></ag-grid-angular>

    <div class="grid-footer" *ngIf="hasPagination">
      <div class="row">
        <div class="col-sm-12 col-md-8 col-lg-8">
          <div class="form-group row" style="margin-bottom: 0">
            <div style="float: left; margin: 0 15px">
              <button
                class="btn btn-default btn-pagination"
                title="Go to first page"
                [disabled]="page === 1"
                [ngClass]="{ disabled: page === 1 }"
                (click)="gotoFirstPage()"
              >
                <i class="fa fa-chevron-left"></i><i class="fa fa-chevron-left"></i>
              </button>
              <button
                class="btn btn-default btn-pagination"
                title="Go to previous page"
                [disabled]="page === 1"
                [ngClass]="{ disabled: page === 1 }"
                (click)="gotoPreviousPage()"
              >
                <i class="fa fa-chevron-left"></i>
              </button>
            </div>
            <div style="float: left; margin: 0 15px">
              <label style="float: left; text-align: right; padding: 0; margin-top: 7px"
                >Page</label
              >
              <input
                type="number"
                class="form-control"
                style="width: 50px; float: left; text-align: center; margin: 0 10px"
                name="page"
                min="1"
                [max]="totalPages"
                [(ngModel)]="page"
                [disabled]="totalPages === 1"
              />
              <label style="float: left; padding: 0; margin-top: 7px">of {{ totalPages }}</label>
            </div>
            <div style="float: left; margin: 0 15px">
              <div class="pull-right">
                <button
                  class="btn btn-default btn-pagination pull-left"
                  title="Go to next page"
                  [disabled]="page === totalPages"
                  [ngClass]="{ disabled: page === totalPages }"
                  (click)="gotoNextPage()"
                >
                  <i class="fa fa-chevron-right"></i>
                </button>
                <button
                  class="btn btn-default btn-pagination pull-left"
                  title="Go to last page"
                  [disabled]="page === totalPages"
                  [ngClass]="{ disabled: page === totalPages }"
                  (click)="gotoLastPage()"
                >
                  <i class="fa fa-chevron-right"></i><i class="fa fa-chevron-right"></i>
                </button>
                <span class="btn-separator"></span>
                <button class="btn btn-default pull-left" title="Reload list" (click)="getData()">
                  <i class="fa fa-refresh"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="hidden-xs hidden-sm col-md-4 col-lg-4">
          <div class="form-group row" style="margin-bottom: 0">
            <label class="col-md-12 form-label" style="text-align: right; margin: 7px -10px"
              >Displaying {{ firstRowIndex }} - {{ lastRowIndex }} of {{ totalCount }}</label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
